import { GameType } from '@/globalVariables/gameTypes'
export const changeMainTitle = (): void => {
  if (import.meta.env.VITE_GAME === GameType.Summer) {
    document.title = 'Summer Sports Mania - Free online summer sports game'
  } else if (import.meta.env.VITE_GAME === GameType.Winter) {
    document.title = 'Winter Sports Mania - Free online winter sports game'
  }
}
